import { render, staticRenderFns } from "./audiobook-table-card.vue?vue&type=template&id=40ffe1ea&scoped=true&"
import script from "./audiobook-table-card.vue?vue&type=script&lang=ts&"
export * from "./audiobook-table-card.vue?vue&type=script&lang=ts&"
import style0 from "./audiobook-table-card.vue?vue&type=style&index=0&id=40ffe1ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ffe1ea",
  null
  
)

export default component.exports